import { MesfModal } from "@dexteel/mesf-core";
import { Box, Button, Typography } from "@mui/material";

interface Props {
	open: boolean;
	onKeepEditing: () => void;
	onDiscard: () => void;
}

// Shared "unsaved changes" guard used both when closing the editor and when
// navigating to another recipe with pending edits.
export const UnsavedChangesModal = ({
	open,
	onKeepEditing,
	onDiscard,
}: Props) => (
	<MesfModal
		id="straightener-recipe-unsaved"
		title="Unsaved changes"
		open={open}
		handleClose={onKeepEditing}
		maxWidth="sm"
	>
		<MesfModal.Content dividers style={{ padding: "15px 30px" }}>
			<Typography>
				You have <strong>unsaved changes</strong>. If you leave now they will be
				lost. Keep editing to save them first.
			</Typography>
		</MesfModal.Content>
		<MesfModal.Actions style={{ padding: "20px 30px 30px" }}>
			<Box
				sx={{
					display: "flex",
					justifyContent: "flex-end",
					gap: 2,
					width: "100%",
				}}
			>
				<Button variant="contained" color="inherit" onClick={onKeepEditing}>
					Keep editing
				</Button>
				<Button variant="contained" color="error" onClick={onDiscard}>
					Discard changes
				</Button>
			</Box>
		</MesfModal.Actions>
	</MesfModal>
);
